<template>
    <!--筛选菜单-->
    <el-row type="flex" :align="align" :justify="justify">
        <div class="zj-filter-menu__title" :style="{marginBottom:realMenuItemStyle.marginBottom}">
            <slot name="title">{{title}}</slot>
        </div>
        <ul class="zj-filter-menu__list"
            :style="{ height: menusHeight }"
            ref="filter-menu__list">
            <li v-for="(item, index) in realOptions"
                :class="[menuItemClass, getIsActive(item, index) ? menuActiveItemClass : undefined]"
                :style="getIsActive(item, index) ? Object.assign({}, realMenuItemStyle, realActiveItemStyle) : realMenuItemStyle"
                @click.stop="onMenuItemClick(item, index)"
                :key="'zj-menu-item-' + index" class="zj-filter-menu__list__item">
                <slot name="menu-item"
                      :item="item"
                      :index="index"
                      :menusLength="realOptions.length">{{ getLabel(item) }}</slot>
            </li>
        </ul>
        <div id="zj-menus-toggle" ref="zj-menus-toggle" v-if="isShowCollapse" :style="{
        height: realMenuItemStyle.height,
        lineHeight: realMenuItemStyle.height
      }" @click.stop="handleToggle">{{toggleType === 'collapse' ? '展开' : '收起'}}
            <i :class="toggleType === 'collapse' ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="margin-left: 6px;"/>
        </div>
    </el-row>
</template>

<script>
/**
 * 是否对象
 */
import resize from "@/components/Charts/mixins/resize"
function isObject (value) {
    return Object.prototype.toString.call(value) === "[object Object]"
}
export default {
    name: "FilterMenu",
    mixins: [resize],
    props: {
        value: {
            type: [String, Number],
            default: "",
            required: true
        },
        // 名称
        title: {
            type: String,
            default: ""
        },
        // 数据项
        menu: {
            type: [Array, Function],
            require: true,
            default () {
                // return ['煤炭开采和洗选业', '有色金属矿采选业', '非金属矿采选业', '其他采矿业', '农副食品加工业', '食品制造业', '饮料制造业', '烟草制品业', '纺织业', '纺织服装、鞋、帽制造业', '皮革、毛皮、羽毛(绒)及其制品业', '木材加工及木、竹、藤、棕、草制品业', '家具制造业', '造纸及纸制品业', '印刷业和记录媒介的复制', '文教体育用品制造业', '石油加工、炼焦及核燃料加工业', '化学原料及化学制品制造业', '医药制造业', '化学纤维制造业', '橡胶制品业', '塑料制品业', '非金属矿物制品业', '黑色金属冶炼及压延加工业']
                return ["煤炭开采和洗选业", "有色金属矿采选业", "非金属矿采选业", "其他采矿业", "农副食品加工业", "食品制造业", "饮料制造业"]
            }
        },
        // labelKey
        labelKey: {
            type: String,
            default: "label"
        },
        valueKey: {
            type: String,
            default: "value"
        },
        // options为function时是否自动加载数据
        auto: {
            type: Boolean,
            default: true
        },
        align: {
            type: String,
            default: "middle",
            validator (val) {
                return ["top", "middle", "bottom"].includes(val)
            }
        },
        justify: {
            type: String,
            default: "space-between",
            validator (val) {
                return ["start", "end", "center", "space-around", "space-between"].includes(val)
            }
        },
        menuItemClass: {
            type: [String, Object, Array]
        },
        menuActiveItemClass: {
            type: [String, Object, Array]
        },
        menuItemStyle: {
            type: Object
        },
        menuActiveItemStyle: {
            type: Object
        },
        menuItemWidth: {
            type: String
        },
        // 最小宽度
        minMenuItemWidth: {
            type: String
        },
        menuItemHeight: {
            type: String,
            default: "26px"
        },
        // 在固定宽度下超过几行出现舌省略号
        lineClamp: {
            type: [Number, String],
            validator (val) {
                return ["", "undefined", "1", "2", "3", "4", "5"].includes(String(val))
            },
        },
        // 是否需要折叠收起
        isCollapse: {
            type: Boolean,
            default: true
        }
    },
    data (vm) {
        vm.toggleTypeMap = {
            collapse: "spread",
            spread: "collapse"
        }
        return {
            customOptions: [],
            isShowCollapse: false,
            toggleType: "collapse"
        }
    },
    watch: {
        realOptions: {
            immediate: true,
            handler () {
                this.getReact()
            }
        }
    },
    computed: {
        optionsIsFn () {
            return typeof this.menu === "function" && (this.menu.then || this.menu.catch)
        },
        realOptions () {
            return this.optionsIsFn ? this.customOptions : this.menu
        },
        // menuItemStyle
        realMenuItemStyle () {
            const style = {
                paddingLeft: "16px",
                paddingRight: "16px",
                borderRadius: "2px",
                marginBottom: "10px",
                marginRight: "10px",
                width: this.menuItemWidth,
                minWidth: this.minMenuItemWidth,
                height: this.menuItemHeight,
                lineHeight: this.menuItemHeight,
                transition: "all .28s",
                fontSize: "14px",
            }
            if (this.lineClamp) {
                Object.assign(style, {
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                })
                if (this.lineClamp > 1) {
                    Object.assign(style, {
                        display: "-webkit-box", // 弹性伸缩盒
                        "-webkit-box-orient": "vertical", // 设置伸缩盒子元素排列方式
                        "-webkit-line-clamp": this.lineClamp
                    })
                }
            }
            return isObject(this.menuItemStyle) ? Object.assign(style, this.menuItemStyle) : style
        },
        realActiveItemStyle () {
            const style = {
                backgroundColor: this.$store.getters.theme || "#256CF4",
                color: "#FFFFFF"
            }
            return isObject(this.menuActiveItemStyle) ? Object.assign(style, this.menuActiveItemStyle) : style
        },
        // 菜单高度
        menusHeight () {
            const { height, minHeight, marginBottom } = this.realMenuItemStyle
            if (this.toggleType === "collapse") {
                if (height) {
                    return `calc(${height} + ${marginBottom})`
                }
                if (minHeight) {
                    return `calc(${minHeight} + ${marginBottom})`
                }
                return "auto"
            } else {
                return "auto"
            }
        }
    },
    created () {
        if (this.auto) {
            this.getData()
        }
    },
    mounted () {
        this.handlerResize(this.getReact)
    },
    methods: {
        getData () {
            if (this.optionsIsFn) {
                this.menu().then(res => {
                    if (isObject(res) && Array.isArray(res.data)) {
                        this.customOptions = res.data
                    } else if (Array.isArray(res)) {
                        this.customOptions = res
                    }
                })
            }
        },
        getLabel (item) {
            return isObject(item) ? item[this.labelKey] : item
        },
        getIsActive (item, index) {
            return isObject(item) ? String(item[this.valueKey]) === String(this.value) : String(index) === String(this.value)
        },
        onMenuItemClick (item, index) {
            const value = isObject(item) ? item[this.valueKey] : index
            this.$emit("input", value)
            this.$emit("change", item, index)
        },
        // 获取节点信息
        getReact () {
            this.$nextTick(() => { // 页面渲染完成后的回调
                const menu = this.$refs["filter-menu__list"]
                const toggle = this.$refs["zj-menus-toggle"]
                let toggleWidth = 0
                if (toggle) {
                    toggleWidth = toggle.clientWidth + 30
                }
                const menuWidth = menu.clientWidth + toggleWidth
                const menuItems = Array.from(menu.children)
                let totalWidth = 0
                for (let i = 0; i < menuItems.length; i++) {
                    totalWidth = totalWidth + menuItems[i].clientWidth + parseFloat(this.realMenuItemStyle.marginRight)
                    if (totalWidth > menuWidth) {
                        break
                    }
                }
                // 存在更多选项
                this.isShowCollapse = totalWidth > menuWidth
            })
        },
        handleToggle () {
            this.toggleType = this.toggleTypeMap[this.toggleType]
        }
    }
}
</script>

<style lang="less">
.zj-filter-menu__title {
    font-weight: 600;
    font-size: 16px;
    margin-right: 8px;
}
.zj-filter-menu__list {
    list-style: none;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    border: none;
    outline: none;
    overflow: hidden;
}
.zj-filter-menu__list__item, #zj-menus-toggle {
    list-style: none;
    box-sizing: border-box;
    border: none;
    outline: none;
    cursor: pointer;
    text-align: center;
    &:hover {
        opacity: 0.8;
    }
}
#zj-menus-toggle {
    margin-left: 30px;
    align-self: start;
}
</style>
